import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
import Add from "./Add";
import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAll,
  Delete,
  Status,
} from "../../../utils/apis/master/state/state";
import { Per_Page_Dropdown } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country } from "../../../utils/apis/common/index";
import Select from "react-select";
import { themedSelectProps } from "../../../utils/selectTheme";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
const Tables = () => {
  const { UnauthorizedLogOut, Select2Data, isAllow } = useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchCountry, setSearchCountry] = useState("");

  const [countries, setCountries] = useState([]);
  const GetAllCountry = async () => {
    const response = await Country();
    if (response?.data?.success) {
      setCountries(await Select2Data(response?.data?.data, "country_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
  }, []);
  const getDataAll = async () => {
    try {
      const response = await findAll(
        currentPage,
        perPage,
        search,
        searchCountry?.value,
      );
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    currentPage,
    searchCountry,
  ]);

  const StatusChange = async (id) => {
    const response = await Status(id);
    setChangeStatus(response);
  };

  const handleDeleteRecord = async () => {
    setModalDeleteShow(false);
    if (recordToDeleteId) {
      const response = await Delete(recordToDeleteId);
      setRecordToDeleteId(null);
      setChangeStatus(response);
      await setShowModal({
        code: response.data.code,
        message: response.data.data,
      });

      setTimeout(() => {
        setShowModal(0);
      }, 2000);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"State"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {isAllow?.includes(18) && (
                <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                  <Button
                    type="button"
                    className="search-btn"
                    onClick={() => setModalShow(true)}>
                    Add
                  </Button>
                </div>
              )}

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Select
                    {...themedSelectProps}
                    isSearchable
                    options={countries}
                    value={searchCountry}
                    placeholder="Select Country"
                    onChange={(e) => {
                      setSearchCountry(e);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Control
                    type="text"
                    placeholder="State Name"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <Button
                  type="button"
                  className="search-btn"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <Button
                  type="button"
                  className="reset-btn"
                  onClick={() => {
                    setSearch("");
                    setSearchCountry("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Country</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                            <td>{d?.Country?.name}</td>
                            <td>{d?.name}</td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={d.status}
                                  onChange={() => {
                                    StatusChange(d.id);
                                  }}
                                  id={`flexSwitchCheckDefault${d?.id}`}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexSwitchCheckDefault${d?.id}`}>
                                  {d.status ? "Active" : "Inactive"}
                                </label>
                              </div>
                            </td>
                            <td>
                              <div className="action-holder">
                                {isAllow?.includes(19) && (
                                  <div
                                    className="icon-holder"
                                    onClick={() => setModalEditShow(d?.id)}>
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </div>
                                )}
                                {isAllow?.includes(20) && (
                                  <div
                                    className="icon-holder"
                                    onClick={() => {
                                      setRecordToDeleteId(d?.id);
                                      setModalDeleteShow(true);
                                    }}>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Add show={modalShow} onHide={() => setModalShow(false)} />

      <Edit show={modalEditShow} onHide={() => setModalEditShow(false)} />
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      />
    </>
  );
};

export default Tables;
